import {
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subject, tap } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';
import { unsubscribeOnDestroy } from '@rs-bank/rs-rxjs-extention';

import { DeviceInformationService } from '../../../../authorization/device-information.service';
import { Wizard } from '../../../../shared/wizard-v2/wizard-core/wizard/wizard';
import { WizardComponent } from '../../../../shared/wizard-v2/wizard-core/wizard/wizard.component';
import { EmailFacade } from '../../../settings/email.facade';
import { SettingsEmail } from '../../../settings/settings.model';
import { StatementRouterParameters } from '../../statements-model';
import { ReferencesFacadeService } from '../references.facade.service';

@Component({
	template: '',
	standalone: false,
})
export class ReferencesWizardBaseComponent extends BaseComponent implements WizardComponent, OnInit {

	public wizard: Wizard;
	public ngUnsubscribe$$: Subject<void> = new Subject<void>();

	public routerParameters: StatementRouterParameters = {productContractId: this.activatedRoute.snapshot.params.productContractId ? +this.activatedRoute.snapshot.params.productContractId : undefined}

	public userEmail: string | undefined;

	constructor(
		public activatedRoute: ActivatedRoute,
		public override changeDetectorRef: ChangeDetectorRef,
		public referencesFacadeService: ReferencesFacadeService,
		public emailFacade: EmailFacade,
		public deviceInformationService: DeviceInformationService,
	) {
		super(changeDetectorRef);
	}

	public ngOnInit(): void {
		this.emailFacade.getEmail()
			.pipe(
				tap((emailData: SettingsEmail) => {
					if (emailData.email) {
						this.userEmail = emailData.email;
					}
				}),
				unsubscribeOnDestroy(this),
			)
			.subscribe();
	}

}